// Client mirror of functions-common/src/charts/datasets/reliability.ts. Keep in sync.

import type { DatasetDefinition } from '../types.js'

export const reliabilityDataset: DatasetDefinition = {
  key: 'reliability',
  labelKey: 'NLSChartDatasetReliability',
  fields: [
    { name: 'person', labelKey: 'NLSChartFieldPerson', kind: 'dimension', type: 'string' },
    { name: 'reliabilityScore', labelKey: 'NLSChartFieldReliabilityScore', kind: 'measure', type: 'number' },
    { name: 'onTimePct', labelKey: 'NLSChartFieldOnTimePct', kind: 'measure', type: 'number' },
    { name: 'proofsApproved', labelKey: 'NLSChartFieldProofsApproved', kind: 'measure', type: 'number' },
    { name: 'proofsReturned', labelKey: 'NLSChartFieldProofsReturned', kind: 'measure', type: 'number' },
    { name: 'day', labelKey: 'NLSChartFieldDay', kind: 'time', type: 'date' },
  ],
  defaultMeasure: { field: 'reliabilityScore', agg: 'avg' },
  defaultTimeField: 'day',
  allowedRoles: ['OWNER', 'ADMIN', 'EDITOR', 'VIEWER', 'HELPER'],
  available: true,
}
